import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import "../../../assets/css/gcstudent/contactUs/ContactPage.css";

// ── SVG Icon Components ─────────────────────────────────────
const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M2 7l10 7 10-7" />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.92 
    1.18 2 2 0 012.92 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L7.09 8.91a16 16 0 006 
    6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

const IconMapPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
    <circle cx="12" cy="9" r="2.5" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const IconUser = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const IconAt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94" />
  </svg>
);

const IconTag = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </svg>
);

const IconMessage = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
  </svg>
);

const IconSend = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 16, height: 16 }}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" style={{ width: 16, height: 16 }}>
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

// ── FAQ Section Icons ─────────────────────────────────────
const IconGraduationCap = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 10L12 5 2 10l10 5 10-5z" />
    <path d="M6 12v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
  </svg>
);

const IconUsersGroup = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87" />
    <path d="M16 3.13a4 4 0 010 7.75" />
  </svg>
);

const IconChevronDown = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25"
    strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// ── Main Component ────────────────────────────────────────────
const ContactPage = () => {
  const { baseUrl } = useContext(AppContext);

  const [formData, setFormData] = useState({
    fullName: '', email: '', subject: '', message: '',
  });

  // status: null | 'loading' | 'success' | 'error'
  const [status, setStatus] = useState(null);
  const [statusMessage, setStatusMessage] = useState('');

  // fallback values jab tak API se library info na aaye
  const [libraryInfo, setLibraryInfo] = useState({
    email: 'info@GGCW Library.edu.pk',
    phone: '+92 300 1234567',
    address: 'Govt Graduate College For women Sattelite Town Gujranwala',
    working_hours: 'Mon – Fri: 8:00 AM – 5:00 PM',
  });

  // Library Config backend se fetch karein
  useEffect(() => {
    axios
      .post(`${baseUrl}/contact/getLibraryInfo`, {})
      .then((res) => {
        if (res.data.success && res.data.libraryConfig) {
          setLibraryInfo(res.data.libraryConfig);
        }
      })
      .catch((err) => console.log(err));
  }, [baseUrl]);

  const contactInfoData = [
    { icon: <IconMail />,   label: 'Email',          value: libraryInfo.email },
    { icon: <IconPhone />,  label: 'Phone',          value: libraryInfo.phone },
    { icon: <IconMapPin />, label: 'Address',        value: libraryInfo.address },
    { icon: <IconClock />,  label: 'Working Hours',  value: libraryInfo.working_hours },
  ];

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    if (status) setStatus(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, subject, message } = formData;

    if (!fullName || !email || !subject || !message) {
      setStatus('error');
      setStatusMessage('Please fill in all fields before sending.');
      return;
    }

    setStatus('loading');

    axios.post(`${baseUrl}/contact/sendContactMessage`, {
      name: fullName,
      email: email,
      subject: subject,
      message: message,
    })
      .then((res) => {
        setStatus('success');
        setStatusMessage(res.data.message || "Your message has been sent successfully! We'll get back to you soon.");
        setFormData({ fullName: '', email: '', subject: '', message: '' });
      })
      .catch((err) => {
        setStatus('error');
        setStatusMessage(err.response?.data?.message || 'Something went wrong. Please try again.');
      });
  };

  // ── FAQ Section State — fully dynamic, loaded from the admin panel ──
  const [activeRole, setActiveRole] = useState('students'); // 'students' | 'teachers'
  const [openFaqIndex, setOpenFaqIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);
  const [faqsLoading, setFaqsLoading] = useState(false);

  // Admin panel se create/update/delete kiye hue FAQs yahan se load hote hain
  useEffect(() => {
    setFaqsLoading(true);
    axios
      .post(`${baseUrl}/admin/faq/getAllFaqs`, {})
      .then((res) => {
        setFaqsLoading(false);
        if (res.data.status) {
          setFaqs(res.data.data);
        }
      })
      .catch((err) => {
        setFaqsLoading(false);
        console.log(err);
      });
  }, [baseUrl]);

  // DB ka audience field ("Student" / "Teacher") is tab key se match karta hai
  const currentFaqs = useMemo(() => {
    const audience = activeRole === 'students' ? 'Student' : 'Teacher';
    return faqs.filter((f) => f.audience === audience);
  }, [faqs, activeRole]);

  const handleRoleSwitch = (role) => {
    if (role === activeRole) return;
    setActiveRole(role);
    setOpenFaqIndex(0);
  };

  const toggleFaq = (idx) => {
    setOpenFaqIndex((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <>
      <section className="gcStudentContactPage">
        <Container>

          {/* ── Main Card ── */}
          <div className="gcStudentContactCard">
            <Row className="g-0">

              {/* ── Left: Form ── */}
              <Col lg={7}>
                <div className="gcStudentFormSection">
                  <h2 className="gcStudentFormSectionTitle">
                    Send us a Message
                  </h2>

                  <form onSubmit={handleSubmit} noValidate>

                    {/* Full Name */}
                    <div className="gcStudentFormGroup">
                      <input
                        type="text"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        placeholder="Full Name"
                        className="gcStudentFormControl"
                        autoComplete="name"
                      />
                      <span className="gcStudentInputIcon"><IconUser /></span>
                    </div>

                    {/* Email */}
                    <div className="gcStudentFormGroup">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email Address"
                        className="gcStudentFormControl"
                        autoComplete="email"
                      />
                      <span className="gcStudentInputIcon"><IconAt /></span>
                    </div>

                    {/* Subject */}
                    <div className="gcStudentFormGroup">
                      <input
                        type="text"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="Subject"
                        className="gcStudentFormControl"
                      />
                      <span className="gcStudentInputIcon"><IconTag /></span>
                    </div>

                    {/* Message */}
                    <div className="gcStudentFormGroup gcStudentTextareaWrapper">
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Your Message"
                        className="gcStudentFormControl"
                        rows={5}
                      />
                      <span className="gcStudentInputIcon"><IconMessage /></span>
                    </div>

                    {/* Status Toast */}
                    {status === 'success' && (
                      <div className="gcStudentToast success">
                        <IconCheck />
                        {statusMessage}
                      </div>
                    )}
                    {status === 'error' && (
                      <div className="gcStudentToast error">
                        <IconAlert />
                        {statusMessage}
                      </div>
                    )}

                    {/* Submit */}
                    <button
                      type="submit"
                      className="gcStudentSendBtn"
                      disabled={status === 'loading'}
                    >
                      {status === 'loading' ? (
                        <>
                          <div className="gcStudentSpinner" />
                          <span>Sending...</span>
                        </>
                      ) : (
                        <>
                          <span>Send Message</span>
                          <IconSend />
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </Col>

              {/* ── Right: Contact Info ── */}
              <Col lg={5}>
                <div className="gcStudentInfoSection">
                  <h2 className="gcStudentInfoSectionTitle">
                    Contact Information
                  </h2>

                  {contactInfoData.map((item, idx) => (
                    <div className="gcStudentInfoCard" key={idx}>
                      <div className="gcStudentInfoIconWrap">
                        {item.icon}
                      </div>
                      <div>
                        <p className="gcStudentInfoLabel">{item.label}</p>
                        <p className="gcStudentInfoValue">{item.value}</p>
                      </div>
                    </div>
                  ))}

                  {/* Map Embed */}
                  {/* <div className="gcStudentMapWrap">
                    <iframe
                      title="University Campus Location"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0!2d-122.4194!3d37.7749!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM!5e0!3m2!1sen!2s!4v1"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div> */}
                </div>
              </Col>

            </Row>
          </div>
        </Container>
      </section>

      {/* ── FAQ Section ── */}
      <section className="gcStudentFaqSection">
        <Container>

          <div className="gcStudentFaqHeader">
            <div className="gcStudentFaqBadge">
              <IconClock />
              <span>Frequently Asked Questions</span>
            </div>

            <h2 className="gcStudentFaqHeading">
              Answers, curated for <span className="gcStudentFaqHeadingAccent">every role</span>
            </h2>

            <p className="gcStudentFaqSubtitle">
              Browse questions from our student and teacher community — updated regularly by our team.
            </p>
          </div>

          <div className="gcStudentFaqTabsWrap">
            <div className="gcStudentFaqTabs">
              <div className={`gcStudentFaqTabSlider ${activeRole === 'teachers' ? 'gcStudentSliderRight' : ''}`} />
              <button
                type="button"
                className={`gcStudentFaqTabBtn ${activeRole === 'students' ? 'active' : ''}`}
                onClick={() => handleRoleSwitch('students')}
              >
                <IconGraduationCap />
                <span>Students</span>
              </button>
              <button
                type="button"
                className={`gcStudentFaqTabBtn ${activeRole === 'teachers' ? 'active' : ''}`}
                onClick={() => handleRoleSwitch('teachers')}
              >
                <IconUsersGroup />
                <span>Teachers</span>
              </button>
            </div>
          </div>

          <div className="gcStudentFaqAccordionCard">
            {faqsLoading && (
              <p className="gcStudentFaqEmptyState">Loading FAQs...</p>
            )}

            {!faqsLoading && currentFaqs.length === 0 && (
              <p className="gcStudentFaqEmptyState">No FAQs available for this section yet.</p>
            )}

            {!faqsLoading && currentFaqs.map((item, idx) => (
              <div
                className={`gcStudentFaqItem ${openFaqIndex === idx ? 'open' : ''}`}
                key={item.id}
              >
                <button
                  type="button"
                  className="gcStudentFaqQuestionBtn"
                  onClick={() => toggleFaq(idx)}
                  aria-expanded={openFaqIndex === idx}
                >
                  <span className="gcStudentFaqNumber">{String(idx + 1).padStart(2, '0')}</span>
                  <span className="gcStudentFaqQuestionText">{item.question}</span>
                  <span className="gcStudentFaqChevron"><IconChevronDown /></span>
                </button>
                <div className="gcStudentFaqAnswerWrap">
                  <div className="gcStudentFaqAnswerInner">
                    <p className="gcStudentFaqAnswerText">{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </Container>
      </section>
    </>
  );
};

export default ContactPage;